
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/osrodky-w-poblizu",
      function () {
        return require("private-next-pages/osrodky-w-poblizu.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/osrodky-w-poblizu"])
      });
    }
  